










import Vue from "vue";
import Search from "@/components/Search.vue";
import ResultList from "@/components/ResultList.vue";
import Homepage from "@/components/Homepage.vue";
import { PayloadFacets } from "@/store/app/types_app";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "Main",
  components: { ResultList, Search, Homepage },
  data(): {
    category: PayloadFacets;
    searching: string;
  } {
    return {
      category: {
        appName: "",
        facetsSelected: [],
      },
      searching: "",
    };
  },
  computed: {
    ...mapGetters(["getShowMainComponent"]),
  },
  methods: {
    receiveSearching(event: string): void {
      this.searching = event;
    },
  },
});
